module.exports = __webpack_public_path__ + "assets/e6fd8c52420c20ed3be821f83226abe9.png";